// TODO: add prop types and default props and remove this linter bypass
/* eslint react/prop-types: 0 */
import { Input, Select } from 'antd';
import React from 'react';

export const SelectInput = ({ disabled, dropdownItems, placeHolder, onChange, width, value }) => (
  <Select
    disabled={disabled}
    getPopupContainer={e => e}
    onChange={onChange}
    placeholder={placeHolder}
    size="large"
    style={{ padding: '3px 10px', width }}
    value={value}
  >
    {dropdownItems.map(selectItem => (
      <Select.Option key={selectItem.value} value={selectItem.value}>
        {selectItem.name}
      </Select.Option>
    ))}
  </Select>
);

export const TextInput = ({ placeholder, onChange, value, width }) => (
  <div style={{ padding: '3px 10px', width }}>
    <Input onChange={onChange} placeholder={placeholder} size="large" value={value} />
  </div>
);
